// Engine API: agent task surfaces (per-task runs, eligibility, bulk dispatch).
// Backed by ~/Dev/seitiate/app/api/v1/tasks.py.

import { engineFetchJson } from '@/lib/engineHttp';
import type {
  AgentRunRead,
  BulkDispatchBody,
  BulkDispatchResponse,
  EligibilityResponse,
} from './agentBoardTypes';

export async function listAgentRunsForTask(
  taskUuid: string,
): Promise<AgentRunRead[]> {
  return engineFetchJson<AgentRunRead[]>(
    `/tasks/${encodeURIComponent(taskUuid)}/agent-runs`,
  );
}

export interface EligibleTasksParams {
  category_prefix?: string;
  days?: number;
  include_blocked?: boolean;
}

export async function listEligibleTasks(
  params: EligibleTasksParams = {},
): Promise<EligibilityResponse> {
  const qs = new URLSearchParams();
  if (params.category_prefix) qs.set('category_prefix', params.category_prefix);
  if (typeof params.days === 'number') qs.set('days', String(params.days));
  if (typeof params.include_blocked === 'boolean') {
    qs.set('include_blocked', String(params.include_blocked));
  }
  const suffix = qs.toString();
  return engineFetchJson<EligibilityResponse>(
    `/tasks/agent/eligible${suffix ? `?${suffix}` : ''}`,
  );
}

export async function bulkDispatchAgentTasks(
  body: BulkDispatchBody,
): Promise<BulkDispatchResponse> {
  return engineFetchJson<BulkDispatchResponse>('/tasks/agent/bulk-dispatch', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export interface DispatchTaskBody {
  agent_type?: string;
  override_budget_cap_usd?: number;
  notes?: string;
  agent_run_id?: string;
}

export interface DispatchTaskResult {
  task: Record<string, unknown>;
  harness_workflow_id: string;
  event_stream_url: string;
}

export async function dispatchTask(
  taskUuid: string,
  body: DispatchTaskBody = {},
): Promise<DispatchTaskResult> {
  return engineFetchJson<DispatchTaskResult>(
    `/tasks/${encodeURIComponent(taskUuid)}/dispatch`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}
